import ChangeEmail from './ChangeEmail.page';

export default ChangeEmail;
